import React, { useContext, useState } from "react";
import AppContext from "../contexts/AppContext";
import { addIssueNote } from "../actions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import FilledInput from "@material-ui/core/FilledInput";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { useTheme } from "@material-ui/core/styles";

import { useTranslation } from "react-i18next";

const NoteForm = (props) => {
  const theme = useTheme();
  const { state, dispatch } = useContext(AppContext);
  const [noteOpen, setNoteOpen] = useState(false);
  const [note, setNote] = useState("");
  const unCreatable = note === "";
  const redmineurl = state.current.redmineurl;
  const apikey = state.current.apikey;
  const { t } = useTranslation();

  const handleNoteWindowOpen = () => setNoteOpen(true);
  const handleNoteWindowClose = () => setNoteOpen(false);
  const handleAddIssueNote = async (id) => {
    const body = {
      issue: { notes: note },
    };
    await addIssueNote(
      redmineurl,
      apikey,
      dispatch,
      id,
      body,
      state.current.user
    );
    setNote("");
    setNoteOpen(false);
  };
  const handleClickClose = () => {
    setNoteOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleNoteWindowOpen}
      >
        {t("issue_detail.label_add_note")}
      </Button>

      <Dialog
        fullWidth
        maxWidth={"md"}
        open={noteOpen}
        onClose={handleNoteWindowClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle
          id="max-width-dialog-title"
          style={{ backgroundColor: theme.palette.secondary.main }}
        >
          <Box
            component={Typography}
            variant="h3"
            paddingTop="1rem"
            paddingBottom="1rem"
            letterSpacing=".04em"
          >
            {t("issue_detail.label_add_note")}
          </Box>
        </DialogTitle>
        <DialogContent
          style={{ backgroundColor: theme.palette.secondary.main }}
        >
          <form noValidate>
            <Grid container>
              <Grid item xs={12}>
                <FormGroup>
                  <FormLabel>{t("issue_detail.field_notes")}</FormLabel>
                  <FormControl
                    variant="filled"
                    component={Box}
                    width="100%"
                    marginBottom="1rem!important"
                  >
                    <Box
                      paddingLeft="0.75rem"
                      paddingRight="0.75rem"
                      component={FilledInput}
                      multiline
                      rows="10"
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                    />
                  </FormControl>
                </FormGroup>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions
          style={{ backgroundColor: theme.palette.secondary.main }}
        >
          <Button onClick={handleClickClose} color="primary" autoFocus>
            {t("button_cancel")}
          </Button>
          <Button
            onClick={(e) => handleAddIssueNote(props.id)}
            variant="contained"
            color="primary"
            disabled={unCreatable}
          >
            {t("button_save")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NoteForm;
